import { render } from "./DashboardProjects.vue?vue&type=template&id=aa70ec60&scoped=true"
import script from "./DashboardProjects.vue?vue&type=script&lang=js"
export * from "./DashboardProjects.vue?vue&type=script&lang=js"

import "./DashboardProjects.vue?vue&type=style&index=0&id=aa70ec60&scoped=true&lang=css"

import exportComponent from "E:\\c2stem\\c2-stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa70ec60"]])

export default __exports__